import { googleAdapter } from "../adapters/googleAdapter";
import AdsTemplateTable from "../common/AdsTemplateTable";
import CreateGoogleTemplateView from "./CreateGoogleTemplateView";

export default function GoogleTemplateTable() {
  return <AdsTemplateTable adapter={googleAdapter} EditDialog={CreateGoogleTemplateView} />;
}